import { IconButton, Tooltip } from '@material-ui/core';
import TableCell from '@material-ui/core/TableCell';
import AssignmentIcon from '@material-ui/icons/Assignment';
import DeleteIcon from '@material-ui/icons/Delete';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import VisibilityIcon from '@material-ui/icons/Visibility';
import moment from 'moment';
import React from 'react';
import { filterTypes } from '../../../toolkit/DataTable/filter-utils';
import ESTADOS_FORMULARIO from '../../../utils/constants';

const AccionesFormulario = ({
  item,
  classes,
  onPdfView,
  onPdfDespachoView,
  onEdit,
  onDelete
  // onTrackingView
}) => {
  return (
    <TableCell className={classes.tableCellAction}>
      <Tooltip title="Consultar" aria-label="consultar">
        <IconButton
          aria-label="consultar"
          onClick={event => {
            if (onEdit) {
              event.preventDefault();
              event.stopPropagation();
              onEdit(item);
            }
          }}
        >
          <VisibilityIcon />
        </IconButton>
      </Tooltip>

      {/* <Tooltip title="Rastrear" aria-label="rastrear">
        <IconButton
          aria-label="rastrear"
          onClick={() => onTrackingView && onTrackingView(item)}
        >
          <LocationOnIcon />
        </IconButton>
      </Tooltip> */}
      <Tooltip title={'Ver'} aria-label="ver">
        <IconButton
          aria-label="ver"
          onClick={event => {
            if (onPdfView) {
              event.preventDefault();
              event.stopPropagation();
              onPdfView(item);
            }
          }}
        >
          <PictureAsPdfIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={'Ver despacho'} aria-label="ver despacho">
        <IconButton
          aria-label="ver despacho"
          onClick={event => {
            if (onPdfDespachoView) {
              event.preventDefault();
              event.stopPropagation();
              onPdfDespachoView(item);
            }
          }}
        >
          <AssignmentIcon />
        </IconButton>
      </Tooltip>
      {item.estadoActual?.estado?.nombre === ESTADOS_FORMULARIO.PENDIENTE && (
        <Tooltip title="Eliminar" aria-label="eliminar">
          <IconButton
            aria-label="delete"
            onClick={() => onDelete && onDelete(item)}
          >
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      )}
    </TableCell>
  );
};

const AccionesFormularioDNA = ({
  item,
  classes,
  onPdfView,
  onEdit
  // onDelete
  // onTrackingView
}) => {
  return (
    <TableCell className={classes.tableCellAction}>
      <Tooltip title="Consultar" aria-label="consultar">
        <IconButton
          aria-label="consultar"
          onClick={event => {
            if (onEdit) {
              event.preventDefault();
              event.stopPropagation();
              onEdit(item);
            }
          }}
        >
          <VisibilityIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title={'Ver'} aria-label="ver">
        <IconButton
          aria-label="ver"
          onClick={event => {
            if (onPdfView) {
              event.preventDefault();
              event.stopPropagation();
              onPdfView(item);
            }
          }}
        >
          <PictureAsPdfIcon />
        </IconButton>
      </Tooltip>
    </TableCell>
  );
};

const formulariosConfig = props => {
  const {
    classes,
    onEdit,
    onDelete,
    onPdfView,
    onPdfDespachoView
    // onTrackingView
  } = props;
  return {
    formularios: {
      datosConfig: {
        titulo: 'Formularios cargados',
        servicio: 'formularios',
        url: 'formularios'
      },
      datosSettings: {
        id: {
          label: 'ID',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.id}</TableCell>
          )
        },
        codigoDespacho: {
          label: 'Despacho',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.codigoDespacho}
            </TableCell>
          )
        },
        codigoTees: {
          label: 'TEES',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.codigoTees}
            </TableCell>
          )
        },
        nroGuia: {
          label: 'Nro. de guía',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.nroGuia}</TableCell>
          )
        },
        'exportador.ruc': {
          label: 'RUC',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {(item.exportador && item.exportador.ruc) || ''}
            </TableCell>
          )
        },
        'exportador.razonSocial': {
          label: 'Exportador',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {(item.exportador && item.exportador.razonSocial) || ''}
            </TableCell>
          )
        },

        'importador.nombre': {
          label: 'Importador',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {(item.importador && item.importador.nombre) || ''}
            </TableCell>
          )
        },
        'importador.pais.nombre': {
          label: 'Destino',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {(item.importador && item.importador.pais.nombre) || ''}
            </TableCell>
          )
        },
        'estadoActual.estado.nombre': {
          label: 'Estado',
          type: filterTypes.SELECTION,
          selectOptions: Object.values(ESTADOS_FORMULARIO).map(value => ({
            label: value,
            value
          })),
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.estadoActual?.estado?.nombre || ''}
            </TableCell>
          )
        },
        fechaCreacion: {
          label: 'Creación',
          type: filterTypes.DATE,
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {moment(item.fechaCreacion).format('DD/MM/YYYY hh:mm:ss')}
            </TableCell>
          )
        },
        actions: {
          label: 'Acciones',
          sortable: false,
          cellRendering: item => (
            <AccionesFormulario
              item={item}
              classes={classes}
              onPdfView={onPdfView}
              onPdfDespachoView={onPdfDespachoView}
              onEdit={onEdit}
              onDelete={onDelete}
              // onTrackingView={onTrackingView}
            />
          )
        }
      }
    },
    formulariosParaDNA: {
      datosConfig: {
        titulo: 'Formularios cargados',
        servicio: 'formularios',
        url: 'formularios'
      },
      datosSettings: {
        id: {
          label: 'ID',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.id}</TableCell>
          )
        },
        nroGuia: {
          label: 'Nro. de guía',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>{item.nroGuia}</TableCell>
          )
        },
        'exportador.ruc': {
          label: 'RUC',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {(item.exportador && item.exportador.ruc) || ''}
            </TableCell>
          )
        },
        'exportador.razonSocial': {
          label: 'Exportador',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {(item.exportador && item.exportador.razonSocial) || ''}
            </TableCell>
          )
        },

        'importador.nombre': {
          label: 'Importador',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {(item.importador && item.importador.nombre) || ''}
            </TableCell>
          )
        },
        'importador.pais.nombre': {
          label: 'Destino',
          type: 'string',
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {(item.importador && item.importador.pais.nombre) || ''}
            </TableCell>
          )
        },
        'estadoActual.estado.nombre': {
          label: 'Estado',
          type: 'string',
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {item.estadoActual?.estado?.nombre || ''}
            </TableCell>
          )
        },
        fechaCreacion: {
          label: 'Creación',
          type: filterTypes.DATE,
          filterable: true,
          sortable: true,
          cellRendering: item => (
            <TableCell className={classes.tableCell}>
              {moment(item.fechaCreacion).format('DD/MM/YYYY hh:mm:ss')}
            </TableCell>
          )
        },
        actions: {
          label: 'Acciones',
          sortable: false,
          cellRendering: item => (
            <AccionesFormularioDNA
              item={item}
              classes={classes}
              onPdfView={onPdfView}
              onEdit={onEdit}
              // onTrackingView={onTrackingView}
            />
          )
        }
      }
    }
  };
};

export default formulariosConfig;
